import { render, staticRenderFns } from "./CheckoutHappyPatientsBadge.vue?vue&type=template&id=088b4614"
import script from "./CheckoutHappyPatientsBadge.vue?vue&type=script&lang=js"
export * from "./CheckoutHappyPatientsBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports